// extracted by mini-css-extract-plugin
export default {"linkWrapper":"ParentalControlsInformer_linkWrapper"};